import type { AxiosInstance } from "axios";

export interface CompanyEnrichmentRequestsQuery {
  readonly page?: number;
  readonly limit?: number;
}

const COMPANY_ENRICHMENT_BASE = "/api/v1/admin/enrichment/company";
const REQUESTS_API_PATH = `${COMPANY_ENRICHMENT_BASE}/requests`;
const TRIGGER_API_PATH = `${COMPANY_ENRICHMENT_BASE}/trigger`;

export function createCompanyEnrichmentAdminApi(apiClient: AxiosInstance) {
  return {
    async getRequests(
      query: CompanyEnrichmentRequestsQuery = {},
    ): Promise<unknown> {
      const response = await apiClient.get(REQUESTS_API_PATH, {
        params: {
          ...(query.page !== undefined && { page: query.page }),
          ...(query.limit !== undefined && { limit: query.limit }),
        },
      });
      return response.data;
    },

    async getRequest(idPublic: string): Promise<unknown> {
      const response = await apiClient.get(
        `${REQUESTS_API_PATH}/${encodeURIComponent(idPublic)}`,
      );
      return response.data;
    },

    async getEnrichedData(idPublic: string): Promise<unknown> {
      const response = await apiClient.get(
        `${COMPANY_ENRICHMENT_BASE}/${encodeURIComponent(idPublic)}`,
      );
      return response.data;
    },

    async trigger(
      companyEnrichmentRequestIdsPublic: readonly string[],
    ): Promise<readonly unknown[]> {
      const response = await apiClient.put<readonly unknown[]>(
        TRIGGER_API_PATH,
        { companyEnrichmentRequestIdsPublic },
      );
      return response.data;
    },
  };
}
